module.exports = __webpack_public_path__ + "img/s2-0-ja.80993040.jpg";